export const ALFAJORES_PARAMS = {
  chainId: "0xaef3",
  chainName: "Alfajores Testnet",
  nativeCurrency: { name: "Alfajores Celo", symbol: "A-CELO", decimals: 18 },
  rpcUrls: ["https://alfajores-forno.celo-testnet.org"],
  blockExplorerUrls: ["https://alfajores-blockscout.celo-testnet.org/"],
  iconUrls: ["future"],
};

export const KLAYTN_PARAMS = {
  chainId: "0x3e9",
  chainName: "Klaytn Testnet Baobab",
  nativeCurrency: { name: "KLAY", symbol: "KLAY", decimals: 18 },
  rpcUrls: ["https://public-en-baobab.klaytn.net"],
  blockExplorerUrls: ["https://scope.klaytn.com"],
  iconUrls: ["future"],
};

export const NEON_PARAMS = {
  chainId: "0xE9AC0CE",
  chainName: "Neon EVM Devnet",
  nativeCurrency: { name: "NEON", symbol: "NEON", decimals: 18 },
  rpcUrls: ["https://devnet.neonevm.org"],
  blockExplorerUrls: ["https://devnet.neonscan.org"],
  iconUrls: ["future"],
};

export const FHENIX_PARAMS = {
  chainId: "0xA455",
  chainName: "Fhenix Network",
  nativeCurrency: { name: "tFHE", symbol: "tFHE", decimals: 18 },
  rpcUrls: ["https://api.testnet.fhenix.zone:7747"],
  blockExplorerUrls: ["https://explorer.testnet.fhenix.zone"],
  iconUrls: ["future"],
};
